<template>
    <div id="menu-mobile" class="menu-mobile" v-bind:class="{ show: showMenu}">
        <h1 id="about-menu-mobile" class="menu-selection" v-on:click="onSelection('about')">
            Sobre
        </h1>
        <h1 id="services-menu-mobile" class="menu-selection" v-on:click="onSelection('services')">
            Serviços
        </h1>
        <h1 id="portfolio-menu-mobile" class="menu-selection" v-on:click="onSelection('portfolio')">
            Portfólio
        </h1>
        <h1 id="guidedtours-menu-mobile" class="menu-selection" v-on:click="onSelection('guided-tours')">
            Visitas Guiadas
        </h1>
        <h1 id="publications-menu-mobile" class="menu-selection" v-on:click="onSelection('publications')">
            Publicações
        </h1>
        <h1 id="contacts-menu-mobile" class="menu-selection" v-on:click="onSelection('contacts')">
            Contactos
        </h1>
    </div>
</template>

<script>
    import anime from "animejs";

    export default {
        name: "MenuMobile",
        props: ['open'],
        data() {
            return {
                showMenu: false
            }
        },
        watch: {
            'open': function () {
                this.toggleMenu();
            }
        },
        methods: {
            toggleMenu() {
                const element = document.querySelector("#menu-mobile");

                if (!this.showMenu) {
                    this.showMenu = this.open;
                }

                anime({
                    targets: element,
                    opacity: this.open ? 1 : 0,
                    duration: 300,
                    easing: 'easeOutQuad'
                }).finished.then(() => this.showMenu = this.open);
            },
            onSelection(selection) {
                const element = document.querySelector("#".concat(selection).concat('-menu-mobile'));

                var tl = anime.timeline({
                    easing: 'easeOutExpo',
                    duration: 100
                });

                tl.add({
                        targets: element,
                        color: '#27348B',
                    })
                    .add({
                        targets: element,
                        color: '#FFF',
                    });

                tl.finished.then(() => this.goToSelection(selection));
            },
            goToSelection(selection) {
                this.$emit('menu-selection', selection);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/styles/global';

    .menu-mobile {
        visibility: hidden;
        background-color: $primary;
        position: fixed;
        height: 100%;
        width: 100%;
        opacity: 0;
    }

    .menu-selection {
        @extend .no-select;
        color: $bgcolor-grey;
        text-transform: uppercase;
        margin-top: 2em;
        margin-bottom: 2em;
    }

    .show {
        visibility: visible;
    }
</style>
